/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trial_EndsInputs */



/**
* | output |
* | --- |
* | "Trial Ends" |
*
* @param {Trial_EndsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const trial_ends = /** @type {((inputs?: Trial_EndsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trial_EndsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin du procès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prozess beendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il processo termina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Судебное разбирательство завершилось.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El juicio termina")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审判结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("裁判終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुकदमा समाप्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O julgamento termina")
	return /** @type {LocalizedString} */ ("Trial Ends")
});